import { getSurveys } from '../../services/data-entry/surveys.service';

//Surveys list
export const UPDATE_SURVEYS_LIST = 'UPDATE_SURVEYS_LIST';
export const TOGGLE_SURVEYS_LIST_LOADING = 'TOGGLE_SURVEYS_LIST_LOADING';
export const SURVEYS_LIST_ERROR = 'SURVEYS_LIST_ERROR';
export const SURVEYS_UPDATE_TOTAL_LIST = 'SURVEYS_UPDATE_TOTAL_LIST';

export const updateSurveysList = (value = []) => ({
  type: UPDATE_SURVEYS_LIST,
  payload: { name: 'list', value }
});

export const surveysListError = (value = null) => ({
  type: SURVEYS_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingSurveys = (value = false) => ({
  type: TOGGLE_SURVEYS_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const updateTotalList = (value = 0) => ({
  type: SURVEYS_UPDATE_TOTAL_LIST,
  payload: { value }
});

export const loadSurveys = (skip = 0, limit = 50, filter, active = true) => {
  return async (dispatch) => {
    try {
      let newFilter = { ...filter };

      if (filter && filter.hasOwnProperty('roles')) {
        newFilter = { ...filter, roles: filter?.roles?.filter((item) => item !== 'all') };
      }

      if (filter && filter.hasOwnProperty('templates')) {
        newFilter = { ...filter, templates: filter?.templates?.filter((item) => item !== 'all') };
      }

      dispatch(toggleLoadingSurveys(true));
      dispatch(surveysListError());

      const { data } = await getSurveys(skip, limit, newFilter, active);

      if (data) {
        dispatch(updateSurveysList(data?.paginatedResults ?? []));
        dispatch(updateTotalList(data?.totalRecords ?? 0));
        return;
      } else {
        dispatch(updateSurveysList([]));
        dispatch(updateTotalList(0));
      }
    } catch (error) {
      dispatch(updateSurveysList([]));
      dispatch(updateTotalList(0));
    } finally {
      dispatch(surveysListError());
      dispatch(toggleLoadingSurveys());
    }
  };
};
